import { CellContext } from "@tanstack/react-table";
import { useContext, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import Textarea from "../../../../../ui/Textarea/Textarea";
import classNames from "classnames";
import styles from "./EditableCell.module.scss";
import TextInput from "../../../../../ui/TextInput/TextInput";
import EditableTableContext from "../EditableTable/EditableTableContext";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function EditableCell({ cell, column }: CellContext<any, string>) {
  const [isOpen, setIsOpen] = useState(false);
  const { control } = useFormContext();
  const { name, disabled } = useContext(EditableTableContext);

  const type = column.columnDef.meta?.type ?? "textarea";

  return (
    <div
      className={classNames(styles.editableCell, {
        [styles.disabled]: disabled,
      })}
    >
      <Controller
        name={`${name}.${cell.row.index}.${cell.column.id}`}
        control={control}
        render={({ field: { onChange, onBlur, value, ref } }) => {
          if (type === "text") {
            return (
              <TextInput
                unstyled
                ref={ref}
                disabled={disabled}
                className={classNames(styles.input, {
                  [styles.expandedInput]: isOpen,
                })}
                value={typeof value === "string" ? value : undefined}
                onFocus={() => setIsOpen(true)}
                onBlur={() => {
                  onBlur();
                  setIsOpen(false);
                }}
                onChange={onChange}
              />
            );
          }

          return (
            <Textarea
              disableNewLine
              ref={ref}
              disabled={disabled}
              className={classNames(styles.input, {
                [styles.expandedInput]: isOpen,
              })}
              value={typeof value === "string" ? value : undefined}
              onFocus={() => setIsOpen(true)}
              onBlur={() => {
                onBlur();
                setIsOpen(false);
              }}
              onChange={onChange}
              size="small"
              maxRows={isOpen ? undefined : 3}
              autosize
              unstyled
            />
          );
        }}
      />
    </div>
  );
}

export default EditableCell;
